module.exports = __webpack_public_path__ + "static/img/follow1.69e6629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/share/follow1.png
// module id = 83re
// module chunks = 1